import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import config from "./config.json";
import { MsalProvider, useMsal } from "@azure/msal-react";
import { BrowserRouter } from "react-router-dom";
import { PublicClientApplication } from "@azure/msal-browser";
import { ProfileProvider } from "./Components/Global/ProfileContext";
import { logout } from "./Services/AccountService";
import { IdleTimerProvider } from "react-idle-timer";





const msalInstance = new PublicClientApplication(config.msalConfig);

const Root: React.FC = () => {
    const { instance } = useMsal();

    return (
        <IdleTimerProvider
            timeout={15 * 60 * 1000}
            debounce={500}
            onIdle={() => {
                // Read accounts fresh at fire-time (avoids a stale-closure of `accounts`,
                // which was empty at first render and stopped logout from ever firing).
                const currentAccounts = instance.getAllAccounts();
                if (currentAccounts.length > 0) {
                    logout(instance, currentAccounts[0]);
                }
            }}
        >
            <ProfileProvider>
                <App />
            </ProfileProvider>
        </IdleTimerProvider>
    );
};

const root = ReactDOM.createRoot(
    document.getElementById("root") as HTMLElement
);

root.render(
    <React.StrictMode>
        <BrowserRouter>
            <MsalProvider instance={msalInstance}>
                <Root />
            </MsalProvider>
        </BrowserRouter>
    </React.StrictMode>
);

